// Sobel edge detection
vec3 effect(vec2 uv)
{
    vec2 px = 1.0 / uResolution;
    float tl = luma(sampleCam(uv + px * vec2(-1.0,  1.0)));
    float t  = luma(sampleCam(uv + px * vec2( 0.0,  1.0)));
    float tr = luma(sampleCam(uv + px * vec2( 1.0,  1.0)));
    float l  = luma(sampleCam(uv + px * vec2(-1.0,  0.0)));
    float r  = luma(sampleCam(uv + px * vec2( 1.0,  0.0)));
    float bl = luma(sampleCam(uv + px * vec2(-1.0, -1.0)));
    float b  = luma(sampleCam(uv + px * vec2( 0.0, -1.0)));
    float br = luma(sampleCam(uv + px * vec2( 1.0, -1.0)));
    float gx = -tl - 2.0 * l - bl + tr + 2.0 * r + br;
    float gy = -tl - 2.0 * t - tr + bl + 2.0 * b + br;
    float edge = length(vec2(gx, gy)) * uAmount * 3.0;
    return vec3(edge) * vec3(0.3, 1.0, 0.6);
}
